import React, { useState, useRef, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import LogoutModal from './Logout';
import '../../styles/ProfileAvatar.css';

export default function ProfileAvatar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [showDropdown, setShowDropdown] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const wrapperRef = useRef(null);

  // Close dropdown if clicked outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const getInitials = () => {
    if (!user) return '?';
    
    // Prefer full_name, fallback to username
    const name = user.full_name || user.username || '';
    const parts = name.trim().split(' ');
    
    if (parts.length === 0) return '?';
    if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
    
    // First letter of first name + First letter of last name
    return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
  };

  const handleLogoutClick = () => {
    setShowDropdown(false); // Close dropdown
    setShowLogoutModal(true); // Open modal
  };

  const handleConfirmLogout = () => {
    logout();
    navigate('/login');
    setShowLogoutModal(false);
  };

  return (
    <>
      <div className="profile-avatar-wrapper" ref={wrapperRef}>
        <div 
            className="pap__avatar" 
            onClick={() => setShowDropdown(!showDropdown)}
            title={user?.full_name || user?.username || 'Profile'}
        >
          {getInitials()}
        </div>

        {showDropdown && (
          <div className="profile-dropdown">
            <div className="profile-dropdown-header">
                <small className="text-muted">Logged in as</small>
                <div className="fw-bold text-truncate" style={{maxWidth: '150px'}}>
                    {user?.full_name || user?.username}
                </div>
            </div>
            <div className="profile-dropdown-divider" />
            <div className="profile-dropdown-item" onClick={handleLogoutClick}>
                <i className="fa-solid fa-right-from-bracket me-2"></i> Logout
            </div>
          </div>
        )}
      </div>

      {showLogoutModal && (
        <LogoutModal 
            onCancel={() => setShowLogoutModal(false)} 
            onConfirm={handleConfirmLogout} 
        />
      )}
    </>
  );
}